import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './shims/ResizeObserver'

import Home from './pages/Home';
import Login from './pages/sessions/Login';
import Logout from './pages/sessions/Logout';
import Setup from './pages/sessions/Setup';
import Blank from './pages/sessions/Blank'
import ForgottenPassword from './pages/sessions/ForgottenPassword';
import PasswordReset from './pages/sessions/PasswordReset';
import SetPassword from './pages/sessions/SetPassword';

import SignUpStart from './pages/sign-up/Start';
import SignUpReturn from './pages/sign-up/Return';

import LocationShow from './pages/locations/Show';
import LocationIndex from './pages/locations/Index';

import FireLogIndex from './pages/fire-log/Index';

import ConfigurationIndex from './pages/configuration/Index';

import PeopleIndex from './pages/people/Index';
import MergePeople from './pages/people/MergePeople';
import SuggestedMerges from './pages/people/SuggestedMerges';

import PlannedEventsIndex from './pages/planned-events/Index';
import PlannedEventsHome from './pages/planned-events/Home';
import MassMailIndex from './pages/mass-mails/Index';

import StaffFulfilmentIndex from './pages/staff-fulfilment/Index';
import StaffFulfilmentShow from './pages/staff-fulfilment/Show';
import TemplateRequirements from './pages/staff-fulfilment/TemplateRequirements';
import WeeklyRequirements from './pages/staff-fulfilment/WeeklyRequirements';
import TemplateShifts from './pages/staff-fulfilment/TemplateShifts';
import WeeklyShiftsByRole from './pages/staff-fulfilment/WeeklyShiftsByRole';
import WeeklyShiftsByPerson from './pages/staff-fulfilment/WeeklyShiftsByPerson';

import BulletinsIndex from './pages/bulletins/Index';

import AnalysisIndex from './pages/analysis/Index';

import ExportsIndex from './pages/exports/Index';
import ExportsEvents from './pages/exports/Events';
import ExportsFeedback from './pages/exports/Feedback';
import ExportsPeople from './pages/exports/People';
import ExportsVisitors from './pages/exports/Visitors';
import ExportsRevenue from './pages/exports/Revenue';
import SalesSummary from './pages/exports/SalesSummary';

import OutstandingActionsIndex from './pages/exports/OutstandingActions';
import ActionsTakenIndex from './pages/exports/ActionsTaken';

import ImportsIndex from './pages/imports/Index';

import UpgradeIndex from './pages/upgrade/Index';

import SupportIndex from './pages/support/Index';

import SettingsIndex from './pages/settings/Index';

import WorkedHoursShow from './pages/worked-hours/Show';
import WorkedHoursIndex from './pages/worked-hours/Index';

import SicknessReportShow from './pages/staff-sickness/Show';
import SicknessReportIndex from './pages/staff-sickness/Index';

import StaffHolidaysShow from './pages/staff-holidays/Show';
import StaffHolidaysIndex from './pages/staff-holidays/Index';

import VersionIndex from './pages/version/Index';

import Error404 from './pages/Error404';

import PersonPreferences from './person-preferences/pages/Index'
import PersonPreferencesLogin from './person-preferences/pages/Login'

import BookingForm from './booking/Index';

import Directory from './directory/Index';

class App extends Component {
  render() {
    const staffFulfilmentRotaRoute = '/staff-fulfilment/:location_id/rotas/:rota_id';
    const staffFulfilmentRoute = '/staff-fulfilment/:location_id';

    return (
      <Router>
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/weekly-feedback/:context' component={Home} />
          <Route exact path='/edit-organisation' component={Home} />

          <Route path='/login' component={Login} />
          <Route path='/logout' component={Logout} />
          <Route path='/setup' component={Setup} />
          <Route path='/blank' component={Blank} />
          <Route path='/forgotten-password' component={ForgottenPassword} />
          <Route path='/password-reset/token/:token' component={PasswordReset} />
          <Route path='/set-password/token/:token' component={SetPassword} />

          <Route path='/sign-up/return' component={SignUpReturn} />
          <Route path='/sign-up/:coupon' component={SignUpStart} />
          <Route path='/sign-up' component={SignUpStart} />

          <Route path='/location/:id/fire-log/history/:fire_log_id' component={LocationShow} />
          <Route path='/location/:id/weekly-feedback/:context' component={LocationShow} />
          <Route path='/location/:id/edit' component={LocationShow} />
          <Route path='/location/:id' component={LocationShow} />
          <Route path='/locations/new' component={LocationIndex} />
          <Route path='/locations' component={LocationIndex} />

          <Route path='/fire-log/history/:fire_log_id' component={FireLogIndex} />
          <Route path='/fire-log/history' component={FireLogIndex} />
          <Route path='/fire-log' component={FireLogIndex} />

          <Route path='/configuration/:page/:id/question/new' component={ConfigurationIndex} />
          <Route path='/configuration/:page/:id/question/:question_id' component={ConfigurationIndex} />
          <Route path='/configuration/:page/new' component={ConfigurationIndex} />
          <Route path='/configuration/:page/:id' component={ConfigurationIndex} />
          <Route path='/configuration/:page' component={ConfigurationIndex} />
          <Route path='/configuration' component={ConfigurationIndex} />

          <Route path='/people/new' component={PeopleIndex} />
          <Route path='/people/:id/events/:event_id' component={PeopleIndex} />
          <Route path='/people/:id' component={PeopleIndex} />
          <Route path='/people' component={PeopleIndex} />
          <Route path='/merge-people' component={MergePeople} />
          <Route path='/suggested-merge-people' component={SuggestedMerges} />

          {
            // Dynamically render Planned Event routes so we can slide in the Appointments alias.
          }
          {["/planned-events", "/appointments"].map((baseRoute) => (
            [
              <Route path={`${baseRoute}/:location_id/:view/:date/new`} component={PlannedEventsIndex} />,
              <Route path={`${baseRoute}/:location_id/:view/:date/:id`} component={PlannedEventsIndex} />,
              <Route path={`${baseRoute}/:location_id/:view/:date`} component={PlannedEventsIndex} />,
              <Route path={`${baseRoute}/:location_id`} component={PlannedEventsIndex} />,
              <Route path={`${baseRoute}`} component={PlannedEventsHome} />,
            ]
          ))}

          <Route path='/mass-mails/new' component={MassMailIndex} />
          <Route path='/mass-mails/:id' component={MassMailIndex} />
          <Route path='/mass-mails' component={MassMailIndex} />

          <Route path='/rota-types/new' component={StaffFulfilmentIndex} />
          <Route path='/rota-types/:id' component={StaffFulfilmentIndex} />

          {
            // Dynamically render Staff Fulfilment routes so we don't need to duplicate blocks for RotaTypes.
            //
            //   staffFulfilmentRotaRoute: "/staff-fulfilment/:location_id/rotas/:rota_id
            //   staffFulfilmentRoute: "/staff-fulfilment/:location_id"
            //
          }
          {[staffFulfilmentRotaRoute, staffFulfilmentRoute].map((baseRoute, index) => (
            [
              <Route path={`${baseRoute}/template/requirements/new`} component={TemplateRequirements} />,
              <Route path={`${baseRoute}/template/requirements/:id`} component={TemplateRequirements} />,
              <Route path={`${baseRoute}/template/requirements`} component={TemplateRequirements} />,

              <Route path={`${baseRoute}/weekly/requirements/new`} component={WeeklyRequirements} />,
              <Route path={`${baseRoute}/weekly/requirements/:id`} component={WeeklyRequirements} />,
              <Route path={`${baseRoute}/weekly/requirements`} component={WeeklyRequirements} />,

              <Route path={`${baseRoute}/template/shifts/new`} component={TemplateShifts} />,
              <Route path={`${baseRoute}/template/shifts/:id`} component={TemplateShifts} />,
              <Route path={`${baseRoute}/template/shifts`} component={TemplateShifts} />,

              <Route path={`${baseRoute}/weekly/shifts/new`} component={WeeklyShiftsByRole} />,
              <Route path={`${baseRoute}/weekly/shifts/:id`} component={WeeklyShiftsByRole} />,
              <Route path={`${baseRoute}/weekly/shifts`} component={WeeklyShiftsByRole} />,

              // Duplicate of the above, for consistency with the below
              <Route path={`${baseRoute}/weekly/shifts-by-role/new`} component={WeeklyShiftsByRole} />,
              <Route path={`${baseRoute}/weekly/shifts-by-role/:id`} component={WeeklyShiftsByRole} />,
              <Route path={`${baseRoute}/weekly/shifts-by-role`} component={WeeklyShiftsByRole} />,

              <Route path={`${baseRoute}/weekly/shifts-by-person/new`} component={WeeklyShiftsByPerson} />,
              <Route path={`${baseRoute}/weekly/shifts-by-person/:id`} component={WeeklyShiftsByPerson} />,
              <Route path={`${baseRoute}/weekly/shifts-by-person`} component={WeeklyShiftsByPerson} />,

              <Route path={baseRoute} component={StaffFulfilmentShow} />
            ]
          ))}

          <Route path='/staff-fulfilment/' component={StaffFulfilmentIndex} />

          <Route path='/bulletins/new' component={BulletinsIndex} />
          <Route path='/bulletins/:id' component={BulletinsIndex} />
          <Route path='/bulletins' component={BulletinsIndex} />

          <Route path='/worked-hours/:id' component={WorkedHoursShow} />
          <Route path='/worked-hours/' component={WorkedHoursIndex} />

          <Route path='/staff-sickness/:id' component={SicknessReportShow} />
          <Route path='/staff-sickness/' component={SicknessReportIndex} />

          <Route path='/staff-holidays/:id' component={StaffHolidaysShow} />
          <Route path='/staff-holidays/' component={StaffHolidaysIndex} />

          <Route path='/analysis/:tab/:chart/:context/:context2' component={AnalysisIndex} />
          <Route path='/analysis/:tab/:chart/:context' component={AnalysisIndex} />
          <Route path='/analysis/:tab' component={AnalysisIndex} />
          <Route path='/analysis' component={AnalysisIndex} />

          <Route path='/exports/events/:id' component={ExportsEvents} />
          <Route path='/exports/events' component={ExportsEvents} />
          <Route path='/exports/feedback/:id' component={ExportsFeedback} />
          <Route path='/exports/feedback' component={ExportsFeedback} />
          <Route path='/exports/people' component={ExportsPeople} />
          <Route path='/exports/visitors/:id' component={ExportsVisitors} />
          <Route path='/exports/visitors' component={ExportsVisitors} />
          <Route path='/exports/revenue' component={ExportsRevenue} />
          <Route path='/exports/sales-summary' component={SalesSummary} />
          <Route path='/exports/outstanding-actions/new' component={OutstandingActionsIndex} />
          <Route path='/exports/outstanding-actions/:id' component={OutstandingActionsIndex} />
          <Route path='/exports/outstanding-actions' component={OutstandingActionsIndex} />
          <Route path='/exports/actions-taken/:id' component={ActionsTakenIndex} />
          <Route path='/exports/actions-taken' component={ActionsTakenIndex} />
          <Route path='/exports' component={ExportsIndex} />

          <Route path='/imports/new' component={ImportsIndex} />
          <Route path='/imports/:id' component={ImportsIndex} />
          <Route path='/imports' component={ImportsIndex} />

          <Route exact path='/settings/users/new' component={SettingsIndex} />
          <Route exact path='/settings/users/:user_id' component={SettingsIndex} />
          <Route path='/settings/' component={SettingsIndex} />

          <Route path='/upgrade' component={UpgradeIndex} />

          <Route path='/support/new' component={SupportIndex} />
          <Route path='/support/faqs/:faq_id' component={SupportIndex} />
          <Route path='/support/faqs/' component={SupportIndex} />
          <Route path='/support/:id' component={SupportIndex} />
          <Route path='/support/' component={SupportIndex} />

          <Route path='/version' component={VersionIndex} />

          <Route path='/email-preferences/:marketing_token' component={PersonPreferences} />
          <Route path='/email-preferences' component={PersonPreferences} />

          <Route path='/person-preferences/login' component={PersonPreferencesLogin} />
          <Route path='/person-preferences' component={PersonPreferences} />

          <Route path='/directory' component={Directory} />

          <Route path='/:page_name/:organisation_info/:location_info' component={BookingForm} />

          <Route component={Error404} />
        </Switch>
      </Router>
    )
  }
}

export default App;
